// Unpublished Work © 2021 Deere & Company

import * as actions from '../../action-list';
import {OriginalCustomerValues} from '../../state/struct/add-customer/original-customer-values';

const setOriginals = (state, action) =>
    OriginalCustomerValues.update(state, {
        $set: action.originalCustomerValues
    });

export const originalCustomerValues = (state = new OriginalCustomerValues({}), action = {}) => {
    const actionHandlers = {
        [actions.SET_EDIT_CUSTOMER]: setOriginals
    };
    const reducer = actionHandlers[action.type];

    return reducer ? reducer(state, action) : state;
};
